import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { SelectField } from '../components/Table/fields/SelectField';
import { enumItems } from './enumItems';
import { SetField } from '../components/Table/fields/SetField';

export const comment: SchemaWithClient<any> = {
  name: 'Comments',
  pluralName: 'Comments',
  columns: {
    name: {
      name: 'Name',
      required: false,
      fieldRenderer: TextField,
      fieldType: 'text',
      hide: true,
    },
    /*group: {
      name: 'Group',
      fieldRenderer: SelectField.tableAdapter(group),
      switchboard: true,
      url: group.client.getAllPath,
      tempSchema: group,
    },
    activity_reservation: {
      name: 'Activity',
      fieldRenderer: SelectField.tableAdapter(activityReservation()),
      url: activityReservation().client.getAllPath,
      tempSchema: activityReservation(),
      switchboard: true,
    },
    accommodation_reservation: {
      name: 'Accommodation',
      fieldRenderer: SelectField.tableAdapter(accommodationReservation()),
      url: accommodationReservation().client.getAllPath,
      tempSchema: accommodationReservation(),
      switchboard: true,
    },
    service_reservation: {
      name: 'Service Reservation',
      fieldRenderer: SelectField.tableAdapter(serviceReservation),
      url: serviceReservation.client.getAllPath,
      tempSchema: serviceReservation,
      switchboard: true,
    },*/
    comment: {
      name: 'Comment',
      fieldRenderer: TextField,
      fieldType: 'textarea',
    },
    user: {
      name: 'User',
      fieldRenderer: SelectField.tableAdapter(enumItems.user),
      url: enumItems.user.client.getAllPath,
      tempSchema: enumItems.user,
      switchboard: true,
    },
    attachments: {
      name: 'Attachments',
      fieldRenderer: SetField.tableAdapter(enumItems.file),
      url: enumItems.file.client.getAllPath,
      tempSchema: enumItems.file,
      switchboard: true,
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },
  client: new Client('/comments'),
};
